import { Axios } from 'src/service/axios/axios'
import { MILESTONE_STATUS_TYPE } from 'src/shared/constants/milestone-constants'
import { NextState } from 'src/shared/constants/workflow-constants'

const BASE_URL = '/api/milestone/workflow'

const nextStates = async (workflowId: string): Promise<Array<NextState>> => {
  return Axios.getAxios()
    .get(`${BASE_URL}/${workflowId}/next-states`)
    .then((response) => response.data)
}

const transition = async (workflowId: string, state: MILESTONE_STATUS_TYPE): Promise<Array<NextState>> => {
  return Axios.getAxios()
    .post(`${BASE_URL}/${workflowId}/transition-to/${state}`)
    .then((response) => response.data)
}

export const MilestoneWorkflowService = {
  nextStates,
  transition,
}
